module.exports = __webpack_public_path__ + "static/media/546GriffinStNW_2018-06-05_16.af9998fd.jpg";